Object.defineProperty(exports,"__esModule",{value:true});exports.victoryInterpolator=exports.interpolateFunction=exports.interpolateImmediate=exports.isInterpolatable=undefined;var _isPlainObject2=require("lodash/isPlainObject");var _isPlainObject3=_interopRequireDefault(_isPlainObject2);var _d3Interpolate=require("d3-interpolate");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}


var isInterpolatable=exports.isInterpolatable=function isInterpolatable(obj){

if(obj!==null){
switch(typeof obj){
case"undefined":
return false;
case"number":


return!isNaN(obj)&&obj!==Number.POSITIVE_INFINITY&&obj!==Number.NEGATIVE_INFINITY;
case"string":


return true;
case"boolean":



return false;
case"object":

return obj instanceof Date||Array.isArray(obj)||(0,_isPlainObject3.default)(obj);
case"function":










return true;}

}
return false;
};
















var interpolateImmediate=exports.interpolateImmediate=function interpolateImmediate(a,b){var when=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;
return function(t){
return t<when?a:b;
};
};













var interpolateFunction=exports.interpolateFunction=function interpolateFunction(a,b){
return function(t){
if(t>=1){
return b;
}
return function(){

var aval=typeof a==="function"?a.apply(this,arguments):a;
var bval=typeof b==="function"?b.apply(this,arguments):b;
return(0,_d3Interpolate.interpolate)(aval,bval)(t);
};
};
};
























var victoryInterpolator=exports.victoryInterpolator=function victoryInterpolator(a,b){



if(a===b||!isInterpolatable(a)||!isInterpolatable(b)){
return interpolateImmediate(a,b);
}
if(typeof a==="function"||typeof b==="function"){
return interpolateFunction(a,b);
}
return(0,_d3Interpolate.interpolate)(a,b);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/victory-core/lib/victory-animation/util.js
 ** module id = 665
 ** module chunks = 0
 **/